<template>
    <div>
        <footer class="footer">
            <div class="wrapper">
                <a href="javascript:void(0)" class="footer-top-btn" @click="pageTop()">
                    <span>PAGE TOP</span>
                </a>
                <p class="col6 col12-sp">
                    <img src="../../../../../../../WebApp/Public/images/necolico_logo.svg" width="117" alt="necolico" />
                    <br />
                    <span class="small">
                        サービス提供：合同会社ネコリコ<br />
                        お問い合わせフォーム：(<a href="https://mamolico-support.necolico.co.jp/" target="_blank">外部リンク</a>)<br />
                        営業時間:平日 9:00-17:00(土日祝日休み)
                    </span>
                </p>
                <dl class="col6 col12-sp vertical-bottom">
                    <dd class="copyright">
                        <a href="https://www.necolico.co.jp/" target="_blank">© necolico LLC</a>
                        <span class="off-sp">｜</span><br class="on-sp" />
                        <a href="https://www.necolico.co.jp/privacypolicy/" target="_blank">個人情報保護方針・特定商取引法に基づく表記</a>
                    </dd>
                </dl>
            </div>
            <!-- wrapper -->
        </footer>
    </div>
</template>
<script>
export default {
    methods: {
        portal: function () {
            // router/index.jsで制御しているため、document.tokenがないことは想定しない
            location.href = "/?id_token=" + document.token;
        },
        pageTop: function () {
            window.scroll({ top: 0, behavior: "smooth" });
        }
    }
};
</script>
